import React, { useState } from 'react';
import { createContainer } from 'unstated-next';
import { usePhoneNumber } from '../../../../../../../common/hooks/use-phone-number';
import {
  AutomationTemplateChannel,
  AutomationTemplateDefinition,
} from './Templates/TemplateDefinitions';

const useAutomationTemplateContainer = () => {
  const [activeTemplate, setActiveTemplate] = useState<{
    template: AutomationTemplateDefinition;
    channel: AutomationTemplateChannel;
  }>();

  const { isSmsSupported: smsSupported, hasNumber: smsEnabled } =
    usePhoneNumber();

  const smsDisableReason: React.ReactNode | undefined = (
    <span>SMS not available</span>
  );

  const closeTemplate = () => setActiveTemplate(undefined);

  return {
    activeTemplate,
    setActiveTemplate,
    closeTemplate,
    smsSupported,
    smsEnabled,
    smsDisableReason,
  };
};

export const AutomationTemplateContainer = createContainer(
  useAutomationTemplateContainer,
);
